import type { FunctionComponent, ReactNode } from 'react'

import ErrorBoundary from '@space-shell/common/components/errorBoundary'
import useInitializeViewAs from '@space-shell/common/hooks/useInitializeViewAs'

import { CommunityConfigurationSidebarProvider } from '@space-shell/modules/communities/communityConfigurationSidebar/context/communityConfigurationSidebar/communityConfigurationSidebarContext'
import { CommunityModalProvider } from '@space-shell/modules/communities/communityModal'

import { CommunitiesSlugMapProvider } from '@space-shell/modules/communities/context/communitiesSlugMapContext/communitiesSlugMapContext'
import { MembersImportProvider } from '@space-shell/modules/communities/context/membersImportProvider/provider'
import { MenuCollapseProvider } from '@space-shell/modules/communities/context/menuCollapseContext/menuCollapseContext'

import { DeleteCommunityModalProvider } from '@space-shell/modules/communities/deleteCommunityModal/context/deleteCommunityModalContext/deleteCommunityModalContext'
import { DeleteCommunityModalOldProvider } from '@space-shell/modules/communities/deleteCommunityModalOld/context/useDeleteCommunityModalOld/useDeleteCommunityModalOld'
import { GroupCommunityModalProvider } from '@space-shell/modules/communities/groupCommunityModal/context/useGroupCommunityModal'

import { GroupDeleteCommunityModalProvider } from '@space-shell/modules/communities/groupDeleteCommunityModal/context/useGroupDeleteCommunityModal'
import { UnbanMemberCommunityModalProvider } from '@space-shell/modules/communities/unbanMemberCommunityModal/context/useUnbanMemberCommunityModal'

import BaseStructure from '../baseStructure'
import { ProductFruitsWrapper } from '../productFruitsWrapper'
import SessionEventsWrapper from '../sessionEventsWrapper'

type BaseLayoutProps = {
  children: ReactNode
}

const providersList = [
  SessionEventsWrapper,
  MenuCollapseProvider,
  ProductFruitsWrapper,
  CommunityModalProvider,
  DeleteCommunityModalProvider,
  DeleteCommunityModalOldProvider,
  GroupCommunityModalProvider,
  UnbanMemberCommunityModalProvider,
  MembersImportProvider,
  CommunityConfigurationSidebarProvider,
  CommunitiesSlugMapProvider,
  GroupDeleteCommunityModalProvider
] as FunctionComponent[]

const compose = (providers: FunctionComponent[]) =>
  providers.reduce((PrevProvider, CurrentProvider) => ({ children }) => (
    <ErrorBoundary>
      <PrevProvider>
        <CurrentProvider>{children}</CurrentProvider>
      </PrevProvider>
    </ErrorBoundary>
  ))

const Providers = compose(providersList)

const BaseLayout = ({ children }: BaseLayoutProps) => {
  useInitializeViewAs()

  return (
    <ErrorBoundary>
      <Providers>
        <BaseStructure>{children}</BaseStructure>
      </Providers>
    </ErrorBoundary>
  )
}

export default BaseLayout
